import React, { createContext, useEffect, useState } from 'react'
import { parseCookies } from 'nookies';
import { useStopwatch } from "react-timer-hook";
import api from '../services/api';

export const WidgetContext = createContext()

export function WidgetProvider({ children }) {
    const [user, setUser] = useState(undefined);
    const [open, setOpen] = useState(true);
    const [showReceivingCall, setShowReceivingCall] = useState(false)
    const [stack, setStack] = useState();
    const [interationSIP, setInterationSIP] = useState();
    const [callInProgress, setCallInProgress] = useState({
        type: "",
        number: "",
        time: "",
        status: "",
        answered_call: "",
    });

    const { seconds, minutes, hours, start, pause, reset } = useStopwatch({
        autoStart: false,
    });
    const [timer, setTimer] = useState("00:00:00");
    const [contact, setContact] = useState(undefined);
    const [mute, setMute] = useState(false);

    useEffect(() => {
        const { 'bcattendant.token': token } = parseCookies()

        if (token) {
            api.get('attendant').then(res => {
                setUser(res.data)
            })
        }
    }, [])

    return (
        <WidgetContext.Provider value={{
            user,
            open,
            setOpen,
            showReceivingCall,
            setShowReceivingCall,
            stack,
            setStack,
            interationSIP,
            setInterationSIP,
            callInProgress,
            setCallInProgress,
            seconds,
            minutes,
            hours,
            start,
            pause,
            reset,
            timer,
            setTimer,
            contact,
            setContact,
            mute,
            setMute
        }}>
            {children}
        </WidgetContext.Provider>
    )
}
